import { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

const BarCode = ({ value, symbology,displayValue,height,width,background,lineColor,margin,fontSize }) => {
  const barcodeRef = useRef(null);
  const props = {
    format: symbology || "CODE128",
    width: width || 1,
    height: height || 20,
    displayValue: displayValue || false,
    background: background || "#ffffff",
    lineColor: lineColor || "#000000",
    margin: margin || 5,
    fontSize: fontSize || 20
  }
  useEffect(() => {
    JsBarcode(barcodeRef.current, value, props);
  }, [value, symbology]);

  return <canvas ref={barcodeRef} />;
};

export default BarCode;